var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPensionPlanGeneric = function SvgPensionPlanGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 813,
    height: 152,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pension-plan-generic_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#320327",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E5B",
    d: "M196.551 198.938c28.352-27.631 28.936-73.013 1.306-101.364L95.187 197.632c27.631 28.351 73.013 28.936 101.364 1.306M533.932 44.274c33.141 21.654 77.561 12.343 99.216-20.798L513.134-54.942c-21.654 33.14-12.343 77.561 20.798 99.216"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.08,
    cy: 48.589,
    r: 58.101,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 793.08,
    cy: 143.589,
    r: 58.101,
    fill: "#FF2E5B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E5B",
    d: "m129.192-47.994 46.006 106.601 106.601-46.005zM669.769 162.948 569.141 105.03l-57.917 100.628zM301.791 117.259l96.205-48.663 48.663 96.205-96.205 48.663z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pension-plan-generic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 10C0 4.477 4.477 0 10 0h793c5.523 0 10 4.477 10 10v132c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
  })))));
};
export { SvgPensionPlanGeneric as ReactComponent };
export default __webpack_public_path__ + "images/pension-plan-generic.svg";